var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Main"}},[_c('transition',{attrs:{"appear":"","name":_vm.isHome ? 'slide-fade-down' : ''}},[_c('TopBar')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }